import React, { useEffect, useState } from "react";
import Page from "../../../components/Page";
import { useNavigate } from "react-router-dom";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-calendar/dist/Calendar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CustomToolbar2 from "./CustomToolBar2";
import CustomEvent from "./CustomEvent";
import _ from "lodash";
// import { postWorkshopTimezone } from "../../../redux/groupWorkshop/actions";
// import CustomEvent from "./CustomEvent";
import "./AddSchedule.scss";
import {
  createSlots,
  deleteSlots,
  deleteSlotsClear,
} from "../../../redux/coaching/actions";
import { Modal, Toast, ToastContainer } from "react-bootstrap";
import AddScheduleComp from "./AddScheduleComp";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/Loader/Loader";
import { SessionKeys } from "../../../utils/AppUtils";
import { getSlots } from "../../../redux/user/actions";
import RescheduleSlotModal from "./RescheduleSlotModal";
import SlotBookingModal from "../../../components/NewDesign/Halifax/Coaching/SlotBookingModal";
import BookingCongratsModal from "../../../components/NewDesign/Halifax/Coaching/BookingCongratsModal";
import ConfirmModal from "../../../components/modal/ConfirmModal";
import Four8HourBookingModal from "../../../components/NewDesign/Halifax/Coaching/Four8HourBookingModal";
import { useTranslation } from "react-i18next";
const AddSchedule = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const deleteSlotsData = useSelector(
    (state) => state.coaching.deleteSlotsData,
  );
  const authBroker = useSelector((state) => state.auth.authBroker);
  const slotsList = useSelector((state) => state.user);
  const userDetailRes = useSelector((state) => state.user.userBroker);

  const localizer = momentLocalizer(moment);
  const [processedEvents, setProcessedEvents] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(true);
  const [showModalMsg, setShowModalMsg] = useState(
    "Would you like to unregister from the session?",
  );
  const [rescheduleMode, setRescheduleMode] = useState(false);
  const [sessionModal, setSessionModal] = useState(false);
  const [selectedCoachId, setSelectedCoachId] = useState("");
  const [productTitle, setProductTitle] = useState("");
  const [productId, setProductId] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [rescheduleFlag, setRescheduleFlag] = useState(false);
  const [congratsModal, setCongratsModal] = useState(false);
  const [participantId, setParticipantId] = useState();
  const [coachingId, setCoachingId] = useState("");
  const [slotsData, setSlotsData] = useState([]);

  const [showFourHourModal, setShowFourHourModal] = useState(false);
  const [requestedHour, setRequestedHour] = useState(4);
  const [selectedRequest, setSelectedRequest] = useState({});

  const handleClose = () => setShow(false);
  const openSlotModalBooking = () => {
    console.log("SlotModalBooking should open now!");
    setSessionModal(true);
    setRescheduleFlag(true);
    setShow(true);
  };
  const handleReschedule = (productid, coachid, coachingId, hour = 1) => {
    console.log("coachid", coachid);

    var requestData = {
      request_type: "slot_reschedule",
      is_coach: true,
    };
    setSelectedRequest(requestData);

    setSelectedCoachId("");
    setProductId(productid);
    setConfirmModal(true);
    setParticipantId(coachid);
    setCoachingId(coachingId);
    setRequestedHour(hour);
    setShowModalMsg("Are you sure you want to Reschedule this session?");
    setIsConfirm(true);
  };

  const navigate = useNavigate();
  const [showAdd, setShowAdd] = useState(false);
  const [show, setShow] = useState(false);
  const [toastShow, setToastShow] = useState(false);
  const minTime = new Date();
  minTime.setHours(8, 0, 0); // 8:00 AM

  const maxTime = new Date();
  maxTime.setHours(22, 0, 0);

  useEffect(() => {
    let idclick = document.getElementById("idNexCal");
    if (idclick !== null) {
      idclick.click();
    }
  }, []);

  const customLocalizer = {
    ...localizer,
    formats: {
      ...localizer.formats,
      dayRangeHeaderFormat: ({ start, end }, culture, localizer) =>
        `${localizer.format(start, "MMMM, Do")} - ${localizer.format(end, "Do YYYY")}`, // Custom format for week/month labels
    },
  };
  let formResetObj = {
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    url: "",
    // timeZone: "",
    weeklyDays: [],
    dayOfMonth: "",
    firstSecondThird: "",
    dayWeekdayWeekend: "",
    monthNo: "",
  };
  const [formData, setFormData] = useState(formResetObj);

  const eventPropGetter = (event) => {
    let className = "";

    if (event.isBooking) {
      className = "join";
    } else if (event.isCancelled) {
      className = "cancelled";
    } else {
      className = "notyetbooked";
    }

    return {
      className, // Add class dynamically
    };
  };

  const getslots = () => {
    if (localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
      console.log("hi");
      dispatch(
        getSlots({
          module: "getSlotList",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
            isprovider: true,
          },
        }),
      );
    }
  };

  const deleteSlotsApi = (slotId) => {
    setIsLoading(true);
    dispatch(
      deleteSlots({
        module: "deleteSlot",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
          slot_id: slotId,
        },
      }),
    );
  };

  useEffect(() => {
    console.log("deleteSlotsData", deleteSlotsData);
    if (!_.isEmpty(deleteSlotsData)) {
      setIsLoading(false);
      if (deleteSlotsData?.status === "success") {
        getslots();
        dispatch(deleteSlotsClear());
      } else {
        console.error("Failed to fetch slots.");
      }
    }
  }, [deleteSlotsData]);

  useEffect(() => {
    console.log("slotsData", slotsList);
    if (!_.isEmpty(slotsList.getSlotsList)) {
      const slotsListing = slotsList.getSlotsList;
      if (slotsListing?.status === "success") {
        setSlotsData(slotsListing?.payload?.payload);
      } else {
        setSlotsData([]);
      }
    }
  }, [slotsList.getSlotsList]);

  useEffect(() => {
    let processedData = [];
    if (slotsData) {
      processedData = slotsData.flatMap((entry) =>
        entry.slot.map((slot) => {
          let startDateTime = moment
            .unix(slot.start_time)
            .tz(userDetailRes?.payload?.payload?.timezoneAbbr);
          let endDateTime = moment
            .unix(slot.end_time)
            .tz(userDetailRes?.payload?.payload?.timezoneAbbr);
          return {
            title: slot.is_booking,
            start: moment(startDateTime.format("YYYY-MM-DD HH:mm")).toDate(),
            end: moment(endDateTime.format("YYYY-MM-DD HH:mm")).toDate(),
            isBooking: slot.is_booking,
            coachId: slot.coach_id,
            userId: slot?.user?.user_id || null,
            bookingId: slot?.user?.booking_id || null,
            isCancelled: slot.is_cancelled || null,
            name: slot?.user?.name,
            profile: slot?.user?.profile,
            url: slot.url,
            id: slot.id,
            slotDate: slot.date,
            coachingId: slot?.user ? slot?.user?.coaching_id : "",
            hour: slot?.hour ? slot?.hour : 1,
            is_locked: slot.is_locked,
          };
        }),
      );
    }
    console.log("processedData: ", processedData);
    setProcessedEvents(processedData);
  }, [slotsData]);

  return (
    <>
      <Loader start={isLoading} />
      <Page>
        <section className="add-schdule pt-4 pb-4">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <button
                  className="mb-4 bck-btn"
                  onClick={() => navigate("/profile/detail")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="17"
                    viewBox="0 0 10 17"
                    fill="none"
                  >
                    <path
                      d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                      fill="black"
                    />
                  </svg>{" "}
                  {t("back")}
                </button>
                <h3 className="mentor-title mb-3 mt-3">Add Schedule</h3>

                <div className="row">
                  <div
                    className={
                      showAdd ? "col-lg-8 transition" : "col-lg-12 transition"
                    }
                  >
                    <Calendar
                      localizer={customLocalizer}
                      events={processedEvents}
                      startAccessor="start"
                      endAccessor="end"
                      views={["day", "week", "month"]}
                      style={{ height: "100%", width: "100%" }}
                      // min={minTime}
                      // max={maxTime}
                      scrollToTime={new Date(1970, 1, 1, 9, 0, 0)}
                      eventPropGetter={eventPropGetter}
                      components={{
                        toolbar: CustomToolbar2,
                        event: (props) => (
                          <CustomEvent
                            {...props}
                            deleteSlotApi={deleteSlotsApi}
                            setShow={setShow}
                            handleReschedule={handleReschedule}
                          />
                        ),
                      }}
                      selectable
                      onSelectSlot={(slotInfo) => {
                        console.log("Selected slot:", slotInfo);
                        const { start, end } = slotInfo;

                        const now = new Date();
                        if (moment(start).isBefore(now, "minute")) {
                          setToastShow(true);
                          return;
                        }

                        // Format time as needed (example: 'HH:mm')
                        let formDataTemp = _.cloneDeep(formData);
                        formDataTemp.startDate =
                          moment(start).format("yyyy-MM-DD");
                        formDataTemp.endDate = moment(end).format("yyyy-MM-DD");

                        let hours = moment(start).hours();
                        if (hours === 23) {
                          formDataTemp.startTime = "23:00";
                          formDataTemp.endTime = "23:59";
                        } else {
                          formDataTemp.startTime =
                            moment(start).format("HH:mm");
                          formDataTemp.endTime = moment(start)
                            .add(1, "hour")
                            .format("HH:mm");
                        }
                        setFormData(formDataTemp);
                        setShowAdd(true);
                      }}
                    />
                  </div>

                  {
                    <AddScheduleComp
                      setProcessedEvents={setProcessedEvents}
                      showAdd={showAdd}
                      setShowAdd={setShowAdd}
                      formData={formData}
                      setFormData={setFormData}
                      formResetObj={formResetObj}
                      getslots={getslots}
                      hour={1}
                    />
                  }
                  <Modal
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                    className="custom-modal"
                    size="lg"
                    centered
                  >
                    <Modal.Header
                      closeButton
                      className="border-0"
                    ></Modal.Header>
                    <Modal.Body className="coach-detail-sec p-4">
                      <div className="de text-center">
                        {sessionModal && (
                          <SlotBookingModal
                            sessionModal={sessionModal}
                            setSessionModal={setSessionModal}
                            coachId={selectedCoachId}
                            setIsLoading={setIsLoading}
                            productTitle={productTitle}
                            productId={productId}
                            displayName={displayName}
                            rescheduleFlag={rescheduleFlag}
                            onCloseModal={() => setShow(false)}
                            setConfirmModal={setConfirmModal}
                            setShowModalMsg={setShowModalMsg}
                            showCancel={true}
                            setShow={setShow}
                            setCongratsModal={setCongratsModal}
                            participantId={participantId}
                            sessionId={coachingId}
                          />
                        )}
                      </div>
                    </Modal.Body>
                  </Modal>
                  <BookingCongratsModal
                    show={congratsModal}
                    setShow={setCongratsModal}
                    slotInfo={""}
                    bookingRequestMsg={false}
                    showRescheduleMsg={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </Page>
      <ToastContainer
        className="b2c-taost  p-3 position-fixed"
        position={"bottom-end"}
        style={{ zIndex: 1002 }}
      >
        <Toast
          show={toastShow}
          delay={3000}
          autohide
          onClose={() => setToastShow(false)}
        >
          <Toast.Body>{"You cannot select past time slots!"}</Toast.Body>
        </Toast>
      </ToastContainer>

      {confirmModal ? (
        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={showModalMsg}
          isConfirm={isConfirm}
          confirmId={""}
          confirmAction={() => {
            setConfirmModal(false); // Close confirm modal
            if (requestedHour === 4 || requestedHour === 8) {
              setShowFourHourModal(true);
            } else {
              openSlotModalBooking(); // Open SlotModalBooking
            }
          }}
          isRightIcon={!isConfirm}
          // clickedItem={clickedItem}
          noAction={() => {}}
        />
      ) : (
        ""
      )}

      <Four8HourBookingModal
        show={showFourHourModal}
        setShow={setShowFourHourModal}
        getRequestList={getslots}
        itemId={coachingId}
        hour={requestedHour}
        selectedRequest={selectedRequest}
      />
    </>
  );
};

export default AddSchedule;
